import { Division } from '@tripointe/tripointe-cms/data-access';
import { matchId } from './array.utils';

export const hasCommunities = (division: Partial<Division>) => !!division.communities.length;

export const hasCommunitiesAndPhases = (division: Partial<Division>) =>
  !!division.communities.length && !!division.phases.length;

const createAssignment = (communityId: number) => (phaseId: number) => ({ communityId, phaseId });

const checkDivisionAssignmentMatch = (communityId: number, phaseId: number) => ({
  communities,
  phases
}) => {
  return communities.find(matchId(communityId)) && phases.find(matchId(phaseId));
};

export const generateCommunitiesWithAssignmentsPayload = (
  divisions: Partial<Division>[],
  { communitiesIds, phasesIds }: { communitiesIds: number[]; phasesIds: number[] }
) => {
  return communitiesIds.reduce((acc, communityId: number) => {
    const phasesIdsFromSameDivision = [...new Set(phasesIds)].filter((phaseId: number) => {
      return divisions.find(checkDivisionAssignmentMatch(communityId, phaseId));
    });
    const assignmentsForCommunity = phasesIdsFromSameDivision.map(createAssignment(communityId));

    return [...acc, ...assignmentsForCommunity];
  }, []);
};
